import styled, { css } from 'styled-components';

const baseGradientBgStyles = css`
  width: 60px;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  display: block;
  z-index: 1;
`;

export const LeftGradientBackground = styled.div`
  ${baseGradientBgStyles};
  background: linear-gradient(to right, white 50%, transparent 100%);

  @media (max-width: 767px) {
    display: none;
  }
`;

export const RightGradientBackground = styled.div`
  ${baseGradientBgStyles};
  left: unset;
  right: 0;
  background: linear-gradient(to left, white 50%, transparent 100%);

  @media (max-width: 767px) {
    display: none;
  }
`;
